import { render, staticRenderFns } from "./seniorSearchList.vue?vue&type=template&id=9b21eb4a&scoped=true&"
import script from "./seniorSearchList.vue?vue&type=script&lang=js&"
export * from "./seniorSearchList.vue?vue&type=script&lang=js&"
import style0 from "./seniorSearchList.vue?vue&type=style&index=0&id=9b21eb4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b21eb4a",
  null
  
)

export default component.exports